import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsGen1.js";

const resultsArr = videoList.Matsuri;

class Matsuri extends React.Component{
    render(){
    
  return(
            <div id="wrapper">

				{/* Header */}
				<Header />

				{/* Menu */}

				{/* Main */}
                <StreamDisplay talentName="Natsuiro Matsuri" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Matsuri